import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_SIZE } from './productListHelper';

export const ProductLoader = ({
  renderGroupContent,
  group,
  groupItems,
  groupChangeStatus,
  groupIndex,
  loadItemsOnDemand,
  isExpandAllInProgress,
  setLoadingItemIds
}) => {
  const { notLoadedItems } = group || {};

  const onLoadMoreItems = !isExpandAllInProgress && loadItemsOnDemand ? async ({ groupId: targetGroupId }) => {
    if (targetGroupId === group?.id && notLoadedItems?.length > 0) {
      const itemsToLoad = notLoadedItems.slice(0, PAGE_SIZE);

      // Mark items as loading if setLoadingItemIds is provided
      if (setLoadingItemIds) {
        setLoadingItemIds((prev) => {
          const newSet = new Set(prev);
          itemsToLoad.forEach((itemId) => newSet.add(itemId));
          return newSet;
        });
      }

      try {
        await loadItemsOnDemand(itemsToLoad);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading items on scroll:', error);
      } finally {
        // Remove items from loading state if setLoadingItemIds is provided
        if (setLoadingItemIds) {
          setLoadingItemIds((prev) => {
            const newSet = new Set(prev);
            itemsToLoad.forEach((itemId) => newSet.delete(itemId));
            return newSet;
          });
        }
      }
    }
  } : null;

  return (
    <>
      {renderGroupContent({
        groupItems,
        group,
        loadMore: onLoadMoreItems,
        groupChangeStatus,
        groupIndex
      })}
    </>
  );
};

ProductLoader.displayName = 'ProductLoader';

ProductLoader.propTypes = {
  renderGroupContent: PropTypes.func.isRequired,
  group: PropTypes.shape({
    id: PropTypes.string,
    notLoadedItems: PropTypes.arrayOf(PropTypes.string)
  }),
  groupItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  groupChangeStatus: PropTypes.arrayOf(PropTypes.bool).isRequired,
  groupIndex: PropTypes.number.isRequired,
  loadItemsOnDemand: PropTypes.func,
  isExpandAllInProgress: PropTypes.bool,
  setLoadingItemIds: PropTypes.func
};

ProductLoader.defaultProps = {
  group: null,
  loadItemsOnDemand: null,
  isExpandAllInProgress: false,
  setLoadingItemIds: null
};
